export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

/**
 * Parse JWT Token
 */
export function parseJwt (token) {
  try{
    return JSON.parse(Buffer.from(token.split('.')[1] || '', 'base64').toString());
  }catch(e){
    return {}
  }
}